import React, { useEffect, useState } from 'react'
import '../../CreateOrganization.scss'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { Button, Grid, TextField } from '@mui/material';
import AppLoader from '../../../../components/AppLoader/AppLoader';
import { Box } from '@mui/system';
import { useFormik } from 'formik';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { cfpBaseUrl } from '../../../../network/urls';
import { Select, Typography, Backdrop } from '@mui/material';
import { MenuItem } from '@mui/material';
import * as Yup from "yup";
import 'react-image-crop/dist/ReactCrop.css'
import { useNavigate } from 'react-router-dom';
import Error from '../../../../components/error/error';
import { allCompaniesAPI } from '../../../../services/Functions';
import { useSelector } from 'react-redux';

const initialValues = {
  iv_company_code: '',
  iv_office_code: '',
  iv_circle_name: '',
  iv_latitude: '',
  iv_longitude: '',
  iv_status: 0, //Active
  iv_is_store: 0,
  iv_cp1_name: '',
  iv_cp1_phone: '',
  iv_cp1_mobile: '',
  iv_cp1_email: '',
  iv_cp2_name: '',
  iv_cp2_phone: '',
  iv_cp2_mobile: '',
  iv_cp2_email: '',
  iv_bank_name: '',
  iv_erp_code: '',
  iv_capital_cost_account_no: '',
  iv_security_cost_account_no: ''
}
const CircleCreationForm = () => {
  const [file, setFile] = useState("")
  const [companyList, setCompanyList] = useState([]);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const { token, code: userOfficeCode, userId: createdBy } = useSelector((state) => state.auth)

  const handleChangeCompany = (event) => {
    handleChange(event); // update the value state with the selected value
    values.iv_office_code = event.target.value;
  };

  const errorCloses = () => {
    setError('')
  }

  useEffect(() => {
    if (userOfficeCode != 10) {
      values.iv_company_code = parseInt(userOfficeCode.toString().slice(0, 2))
    }
  }, [])

  useEffect(() => {
    const callAllCompanies = async () => {
      setViewBackdrop(true)
      let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
      if (companiesList) {
        companiesList = companiesList.filter(item => item.companyCode != 1)
        let cpList = companiesList.map(item => ({
          code: item.companyCode,
          name: item.companyName
        }))
        setCompanyList(cpList)
      }
      setViewBackdrop(false);
    }
    callAllCompanies()
  }, [])

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_company_code: Yup.mixed().required('Select Company'),
      iv_office_code: Yup.string().required('Enter office code.'),
      iv_circle_name: Yup.string().required("Enter circle name."),
      iv_latitude: Yup.string().required("Enter latitude."),
      iv_longitude: Yup.string().required("Enter longitude."),
      iv_status: Yup.mixed().required('Select status.'),
      iv_is_store: Yup.mixed().required('Select is store.'),
      iv_cp1_name: Yup.string().required("Fullname is required").min(2, `Name can't be less than 2 characters!`).max(50, `Name can't be more than 50 characters!`),
      iv_cp1_phone: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Enter Phone No.").matches(/^0[0-9]{10}$/, "Enter Phone no. as 04237894561."),
      iv_cp1_mobile: Yup.string().min(11, "Mobile no. can not less than 11 digits.").max(11, "Mobile no. can not greater than 11 digits.").required("Enter Mobile No.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Mobile no. as 03001234567."),
      iv_cp1_email: Yup.string().email("Enter email as 'john@gmail.com'.").required('Enter email address.'),
      iv_cp2_name: Yup.string().required("Fullname is required").min(2, `Name can't be less than 2 characters!`).max(50, `Name can't be more than 50 characters!`),
      iv_cp2_phone: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Enter Phone No.").matches(/^0[0-9]{10}$/, "Enter Phone no. as 04237894561."),
      iv_cp2_mobile: Yup.string().min(11, "Mobile no. can not less than 11 digits.").max(11, "Mobile no. can not greater than 11 digits.").required("Enter Mobile No.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Mobile no. as 03001234567."),
      iv_cp2_email: Yup.string().email("Enter email as 'john@gmail.com'.").required('Enter email address.'),
      iv_bank_name: Yup.string().required("Enter bank name."),
      iv_erp_code: Yup.string().required('Enter ERP code.'),
      iv_capital_cost_account_no: Yup.string().required("Enter account no. for capital cost."),
      iv_security_cost_account_no: Yup.string().required("Enter account no. for security cost."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      var formdata = new FormData();

      formdata.append("companyCode", values.iv_company_code);
      formdata.append("circleCode", values.iv_office_code);
      formdata.append("circleName", values.iv_circle_name);
      formdata.append("cp1Name", values.iv_cp1_name);
      formdata.append("cp1phone", values.iv_cp1_phone);
      formdata.append("cp1Mobile", values.iv_cp1_mobile);
      formdata.append("cp1Email", values.iv_cp1_email);
      formdata.append("cp2Name", values.iv_cp2_name);
      formdata.append("cp2phone", values.iv_cp2_phone);
      formdata.append("cp2Mobile", values.iv_cp2_mobile);
      formdata.append("cp2Email", values.iv_cp2_email);
      formdata.append("longitude", values.iv_longitude);
      formdata.append("latitude", values.iv_latitude);
      formdata.append("status", values.iv_status);
      formdata.append("isStore", values.iv_is_store);
      formdata.append("createdBy", createdBy);
      formdata.append("circleBankName", values.iv_bank_name);
      formdata.append("circleErpCode", values.iv_erp_code);
      formdata.append("circleCapitalCostAccountNo", values.iv_capital_cost_account_no);
      formdata.append("circleSecurityAccountNo", values.iv_security_cost_account_no);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/addCircle", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === '200') {
            navigate('/circle-management')
          }
          else {
            setError(result.message)
          }
        })
        .catch(error => {
          setError(error)
        });
      setViewBackdrop(false);
    }
  });

  return (
    <>
      <Grid className='creation'>
        <Grid container className='creationContainer'>
          <Grid item lg={12}>
            <h3 className='heading'>
              Add New Circle
            </h3>
          </Grid>
          <Grid item lg={12} className='form'>
            <Grid container >
              <Grid item lg={12}>
                <Grid container spacing={1}>
                  <Grid item lg={12}>
                    <h4>Basic Information</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Company</label>
                        <Select
                          fullWidth
                          value={values.iv_company_code}
                          onChange={handleChangeCompany}
                          disabled={userOfficeCode != 10}
                          sx={{ height: '45px', width: '100%' }}
                          onBlur={handleBlur}
                          name="iv_company_code"
                          id="iv_company_code"
                          displayEmpty
                        >
                          <MenuItem value=''>Select Company</MenuItem>
                          {
                            companyList.map(item => {
                              return <MenuItem value={item.code}>{item.name}</MenuItem>
                            })
                          }
                        </Select>
                        <Grid>
                          {
                            errors.iv_company_code && touched.iv_company_code ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_company_code}</p>
                            ) : null
                          }
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Office Code</label>
                        <TextField type='number' maxLength='5' onChange={handleChange} name="iv_office_code" value={values.iv_office_code} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                          {errors.iv_office_code && touched.iv_office_code ? (errors.iv_office_code) : null}
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Circle Name</label>
                        <TextField type='text' maxLength='5' onChange={handleChange} name="iv_circle_name" value={values.iv_circle_name} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                          {errors.iv_circle_name && touched.iv_circle_name ? (errors.iv_circle_name) : null}
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Latitude</label>
                        <TextField type='number' maxLength='5' onChange={handleChange} name="iv_latitude" value={values.iv_latitude} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                          {errors.iv_latitude && touched.iv_latitude ? (errors.iv_latitude) : null}
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Longitude</label>
                        <TextField type='number' maxLength='5' onChange={handleChange} name="iv_longitude" value={values.iv_longitude} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                          {errors.iv_longitude && touched.iv_longitude ? (errors.iv_longitude) : null}
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Status</label>
                        <Grid>
                          {
                            errors.iv_status && touched.iv_status ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_status}</p>
                            ) : null
                          }
                        </Grid>
                        <FormControl >
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="iv_status"
                            id="iv_status"
                            className='radio'
                            value={values.iv_status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <FormControlLabel value={0} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Active' />
                            <FormControlLabel value={1} className='option-left' sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Inactive' />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Is Store</label>
                        <Grid>
                          {
                            errors.iv_is_store && touched.iv_is_store ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_is_store}</p>
                            ) : null
                          }
                        </Grid>
                        <FormControl >
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="iv_is_store"
                            id="iv_is_store"
                            className='radio'
                            value={values.iv_is_store}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <FormControlLabel value={0} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='No' />
                            <FormControlLabel value={1} className='option-left' sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Yes' />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12}>
                <Grid container spacing={1}>
                  <Grid item lg={12}>
                    <h4>Bank Information</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container sx={{ padding: '0px 10px' }}>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Bank Name</Typography>
                        <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_bank_name" value={values.iv_bank_name} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid className="from-Error">
                          {
                            errors.iv_bank_name && touched.iv_bank_name ? errors.iv_bank_name : null
                          }
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">ERP Code</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_erp_code"
                          autoComplete="off"
                          value={values.iv_erp_code}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 6 }}
                          id="iv_erp_code"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_erp_code && touched.iv_erp_code
                            ? errors.iv_erp_code
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Capital Cost Account No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_capital_cost_account_no"
                          autoComplete="off"
                          value={values.iv_capital_cost_account_no}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 14 }}
                          id="iv_capital_cost_account_no"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_capital_cost_account_no && touched.iv_capital_cost_account_no
                            ? errors.iv_capital_cost_account_no
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }} >
                        <Typography className="fieldLabel">Security Cost Account No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_security_cost_account_no"
                          autoComplete="off"
                          value={values.iv_security_cost_account_no}
                          inputProps={{ maxLength: 14 }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="iv_security_cost_account_no"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_security_cost_account_no && touched.iv_security_cost_account_no
                            ? errors.iv_security_cost_account_no
                            : null}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12}>
                    <h4>First Contact Person Information</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container sx={{ padding: '0px 10px' }}>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Full Name</Typography>
                        <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_cp1_name" value={values.iv_cp1_name} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid className="from-Error">
                          {
                            errors.iv_cp1_name && touched.iv_cp1_name ? errors.iv_cp1_name : null
                          }
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Phone No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp1_phone"
                          autoComplete="off"
                          value={values.iv_cp1_phone}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 11 }}
                          id="iv_cp1_phone"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp1_phone && touched.iv_cp1_phone
                            ? errors.iv_cp1_phone
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Mobile No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp1_mobile"
                          autoComplete="off"
                          value={values.iv_cp1_mobile}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 11 }}
                          id="iv_cp1_mobile"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp1_mobile && touched.iv_cp1_mobile
                            ? errors.iv_cp1_mobile
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }} >
                        <Typography className="fieldLabel">Email</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp1_email"
                          autoComplete="off"
                          value={values.iv_cp1_email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="iv_cp1_email"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp1_email && touched.iv_cp1_email
                            ? errors.iv_cp1_email
                            : null}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12}>
                    <h4>Second Contact Person Information</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container sx={{ padding: '0px 10px', height: '20vh' }}>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Full Name</Typography>
                        <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_cp2_name" value={values.iv_cp2_name} onBlur={handleBlur} sx={{
                          width: '100%', '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }} />
                        <Grid className="from-Error">
                          {
                            errors.iv_cp2_name && touched.iv_cp2_name ? errors.iv_cp2_name : null
                          }
                        </Grid>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Phone No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp2_phone"
                          autoComplete="off"
                          value={values.iv_cp2_phone}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 11 }}
                          id="iv_cp2_phone"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp2_phone && touched.iv_cp2_phone
                            ? errors.iv_cp2_phone
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                        <Typography className="fieldLabel">Mobile No.</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp2_mobile"
                          autoComplete="off"
                          value={values.iv_cp2_mobile}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 11 }}
                          id="iv_cp2_mobile"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp2_mobile && touched.iv_cp2_mobile
                            ? errors.iv_cp2_mobile
                            : null}
                        </Box>
                      </Grid>
                      <Grid item lg={3} sx={{ padding: '0px 10px' }} >
                        <Typography className="fieldLabel">Email</Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_cp2_email"
                          autoComplete="off"
                          value={values.iv_cp2_email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="iv_cp2_email"
                          sx={{
                            width: '100%', '.MuiInputBase-input': {
                              height: '1vh',
                            },
                          }}
                        />
                        <Box className="from-Error">
                          {errors.iv_cp2_email && touched.iv_cp2_email
                            ? errors.iv_cp2_email
                            : null}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12}>
                {
                  error &&
                  <Error
                    error={error}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>

            <Grid container sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
              <Grid item lg={12} sx={{ padding: '0px 10px', textAlign: 'right' }}>
                <Button sx={{ width: '10%' }} variant="contained" size='medium' onClick={handleSubmit}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >
    </>
  )
}

export default CircleCreationForm
